var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87946 3.26581H2.53148C1.51694 3.26581 0.694489 4.027 0.694489 4.96597V16.3004C0.694489 17.2394 1.51694 18.0006 2.53148 18.0006H9.87946C10.894 18.0006 11.7165 17.2394 11.7165 16.3004V4.96597C11.7165 4.027 10.894 3.26581 9.87946 3.26581Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1427 2.70016C3.1427 1.76119 3.96515 1 4.97969 1H12.3277C13.3422 1 14.1647 1.76119 14.1647 2.70016V14.0346C14.1647 14.9735 13.3422 15.7348 12.3277 15.7348",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/_copy.95ce8a5de1506c3d55591b99773c08f7.svg";
export { ForwardRef as ReactComponent };